import React from 'react';
import {Outlet} from 'react-router-dom';
import {styled, useTheme} from '@mui/material/styles';
import {Box, useMediaQuery} from '@mui/material';

const Main = styled((props) => <main {...props} />)(({theme}) => ({
    width: '100%',
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.up('md')]: {
        //marginLeft: -drawerWidth,
        //width: `calc(100% - ${drawerWidth}px)`
    }
}));

const OutletDiv = styled((props) => <div {...props} />)(({theme}) => ({
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(3)
    },
    padding: theme.spacing(5)
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const [drawerOpen, setDrawerOpen] = React.useState(false);

    React.useEffect(() => {
        setDrawerOpen(matchUpMd);
    }, [matchUpMd]);

    return (
        <Box sx={{display: 'flex', width: '100%'}}>
            <Main
                style={{
                    ...(drawerOpen && {
                        transition: theme.transitions.create('margin', {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen
                        }),
                        marginLeft: 0,
                        marginRight: 'inherit'
                    })
                }}
            >
                <OutletDiv className="grid-full">
                    <Outlet/>
                </OutletDiv>
            </Main>
        </Box>
    );
};

export default MainLayout;
